/**
 * Integration module constants
 * Centralizes all hardcoded values for better maintainability and type safety
 */

import LightspeedIcon from 'packages/@slerp/assets/integrations/lightspeed.png'
import ShipdayIcon from 'packages/@slerp/assets/integrations/shipday.png'

export enum PartnerName {
  LIGHTSPEED = 'LIGHTSPEED',
  SHIPDAY = 'SHIPDAY'
}

export const PARTNER_SLUGS = {
  LIGHTSPEED: 'lightspeed-pos',
  SHIPDAY: 'shipday'
} as const

export const PARTNER_DISPLAY_NAMES = {
  LIGHTSPEED: 'Lightspeed',
  SHIPDAY: 'Shipday'
} as const

export const INTEGRATION_CATEGORIES = {
  POS: 'POS',
  DELIVERY: 'DELIVERY'
} as const

export const INTEGRATION_CATEGORY_LABELS: Record<string, string> = {
  POS: 'POS',
  DELIVERY: 'Delivery'
}

export type IntegrationRegistryEntry = {
  slug: string
  name: string
  description: string
  icon: string
}

export const INTEGRATION_REGISTRY: Record<
  PartnerName,
  IntegrationRegistryEntry
> = {
  [PartnerName.LIGHTSPEED]: {
    slug: PARTNER_SLUGS.LIGHTSPEED,
    name: PARTNER_DISPLAY_NAMES.LIGHTSPEED,
    description:
      'Integrate Lightspeed with Slerp to sync point-of-sale data and ensure loyalty and customer interactions work seamlessly at checkout.',
    icon: LightspeedIcon
  },
  [PartnerName.SHIPDAY]: {
    slug: PARTNER_SLUGS.SHIPDAY,
    name: PARTNER_DISPLAY_NAMES.SHIPDAY,
    description:
      "Shipday lets you dispatch and track your own delivery drivers directly from Slerp. Before continuing, you'll need a Shipday merchant account.",
    icon: ShipdayIcon
  }
}

export type PartnerNameType = keyof typeof PartnerName
export type PartnerSlug = (typeof PARTNER_SLUGS)[keyof typeof PARTNER_SLUGS]

/**
 * Helper to get partner name in lowercase (for API comparisons)
 */
export const getPartnerNameLowercase = (partnerName: PartnerName): string => {
  return partnerName.toLowerCase()
}

/**
 * Helper to check if a partner name matches
 */
export const isPartner = (name: string, partner: PartnerName): boolean => {
  return name.toLowerCase() === partner.toLowerCase()
}

export const SHIPDAY_APP_URL =
  'https://dispatch.shipday.com/dashboard#integrations'
export const SHIPDAY_SIGNUP_URL =
  'https://dispatch.shipday.com/signUp/Uxz6fVxLkO'
export const SHIPDAY_HELP_URL =
  'https://support.slerp.com/knowledge/shipday-integration'
